import { motion } from "framer-motion";
import { HomeLayout } from "layouts";
import { useEffect, useRef, useState } from "react";
import * as cx from "classnames/bind";
import { useGQLSWR, fetcher, imageUrl, translate } from "utils";
import { gql } from "graphql-request";

import { useRouter } from "next/router";
import { cocktailFragmentWithOutMeta as cocktailFragment } from "queries/fragments";
import { Cocktail as CocktailComponent } from "components";
import { cocktailTransformer } from "queries/transformers";

import { Section, Container, CreateListModal } from "components";

import s from "styles/Journal.module.scss";
import g from "styles/Gallery.module.scss";

import data from "/public/postdata.json";
import Link from "next/link";
import Image from "next/legacy/image";
import Head from "next/head";
import urlSlug from "url-slug";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";

import { ArticlePage as Article } from "components/pages/articles.js";

Article.getLayout = (page) => {
  return <HomeLayout className={cx("Post", s.postHolder)}>{page}</HomeLayout>;
};

export async function getStaticProps({ locale, params: { slug, category } }) {
  const query = gql`
    query {
        articles( where: { slug: { _eq: "${slug}" } }) {
            id
            title
            slug
            excerpt
            image_id
            translations
            extra_data
            embed_code
            hidden
            categories {
                category {
                    name
                    slug
                    translations
                }
            }
        }
        category: article_categories(where: {slug: {_eq: "${category}"}}) {
            id
            name
            slug
            translations
        }
    }
  `;

  const data = await fetcher(query);
  if (data.articles.length < 1) {
    return {
      notFound: true,
    };
  }
  return {
    props: {
      article: data.articles[0],
      category: data.category[0],
      ...(await serverSideTranslations(locale)),
    },
    revalidate: 60,
  };
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export default Article;
